<template>
  <div>
    <div class="why-choose-content margin-general">
      <div class="why-choose-title-container">
        <h2>{{ $t(title) }}</h2>
      </div>
      <!-- <div class="why-choose-subTitle-container">
        <p class="subTitle body-4">{{ $t(subTitle) }}</p>
      </div> -->
      
      <div class="why-choose-carousel">
        <div class="what-choose-box">
          <div class="carousel-container">
            <ClientOnly>
              <swiper
                :modules="modules"
                :slides-per-view="1"
                :space-between="36"
                :navigation="true"
                :loop="true"
                :virtual="true"
                :initial-slide="0"
                class="slidePortafolio"
                :slides-per-group="1"
                :breakpoints="{
                  '824': {
                    slidesPerView: 4,
                    spaceBetween: 36,
                    slidesPerGroup: 1,
                  },
                }"
              >
                <swiper-slide v-for="(card, index) in getCards(props.platformView)" :key="index">
                  <div class="slide">
                    <div class="icon-box">
                      <span class="material-symbols-outlined icon" translate="no">
                        {{ card.icon }}
                      </span>
                    </div>
                    <p class="description body-4">
                      {{ $t(card.description) }}
                    </p>
                    <NuxtLink
                      class="find-more link-4"
                      v-if="card.findOut"
                      :to="localPath(card.findOut)"
                    >
                      {{ $t("company.why-choose.button") }}
                    </NuxtLink>
                  </div>
                </swiper-slide>
              </swiper>
            </ClientOnly>
          </div>
        </div>
      </div>
    </div>

    <div class="what-choose-box-responsive">
      <div v-for="(item, index) in getCards(props.platformView)" :key="index" class="card">
        <div class="icon-box">
          <span class="material-symbols-outlined icon" translate="no">{{ item.icon }}</span>
        </div>
        <p class="description body-4">{{ $t(item.description) }}</p>
        <NuxtLink
          v-if="item.findOut"
          class="find-more link-4"
          :to="localPath(item.findOut)"
        >
          {{ $t("company.why-choose.button") }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Navigation, Autoplay, Virtual } from "swiper/modules";

const localPath = useLocalePath();

const props = defineProps({
  title: { type: String, default: 'company.why-choose.title' },
  platformView: { type: Boolean, default: false },
  /* subTitle: { type: String, default: 'company.why-choose.subTitle' } */
});

const baseCards = [
  { icon: "fullscreen_exit", description: "company.why-choose.card1" },
  { icon: "database", description: "company.why-choose.card3" },
  { icon: "support_agent", description: "company.why-choose.card5" },
  { icon: "account_circle", description: "company.why-choose.card6" },
  { icon: "finance", description: "company.why-choose.card7" },
  { icon: "account_balance_wallet", description: "company.why-choose.card8" },
  { icon: "feature_search", description: "company.why-choose.card9", findOut: "/company/regulation" },
  { icon: "lock", description: "company.why-choose.card10" },
];

const cards = computed(() => {
  return baseCards;
});

function getCards(platformview){
  if (platformview){
    return [...baseCards, { icon: "jamboard_kiosk", description: "company.why-choose.card11" }];
  }else{
    return [...baseCards, { icon: "jamboard_kiosk", description: "company.why-choose.card11",findOut: "/trading/platforms" }];
  }
}

// 4. Módulos limpios sin Virtual
const modules = [Pagination, Navigation, Autoplay, Virtual];
</script>